import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

@Injectable({
  providedIn: 'root'
})
export class VendorGroupsRatesService {

  constructor(
      private restangular: ApiClient
  ) { }

  getAllVendorGroupRates(limit = 10000, offset = 0, search = ''): Promise<any> {
    return this.restangular.one(`/vendors/groups/rates?limit=${limit}&offset=${offset}&search=${encodeURIComponent(search)}`).get().toPromise();
  }

  createVendorGroupRate(productId: string, companyIds: string[], metadata: any): Promise<any> {
    return this.restangular.one('/vendors/groups/rates').customPOST({
      vendorProductId: productId,
      companyIds,
      metadata,
    }).toPromise();
  }

  modifyVendorGroupRate(id: string, fields: any): Promise<any> {
    return this.restangular.one('/vendors/groups/rates', id).customPUT({
      ...fields
    }).toPromise();
  }

  deleteVendorGroupRate(id: string): Promise<any> {
    return this.restangular.one('vendors/groups/rates', id).remove().toPromise();
  }

}
